import PublishCountrySelectorRedirect from "../../events/countrySelectorRedirect"
import {COUNTRY_SELECTOR_REDIRECT_QUERY_STRING} from "../../config/constants"

const redirectPage = (selectedCountry, selectedLanguage) => {
    PublishCountrySelectorRedirect()

    const selectedLang = selectedCountry?.Languages.find(l => l.Name === selectedLanguage)
    if (selectedLang) {
        window.location.href = `${selectedLang.TargetUrl}?${COUNTRY_SELECTOR_REDIRECT_QUERY_STRING}=true`
    }
}

export default redirectPage
